export const cleanAndConvertToFloat = (value) => {
  if (typeof value === "string") {
    const cleanStr = value.replace(/[^0-9.,]+/g, "");
    const dotStr = cleanStr.replace(".", "").replace(",", ".");

    return parseFloat(dotStr);
  }

  return value;
};

/**
 * Removes all non-digit characters from a phone number string.
 * @param {string} phone - The phone number string to clean.
 * @returns {string} The cleaned phone number containing only digits.
 */
export const cleanPhoneMask = (phone) => {
  return phone.replace(/\D/g, "");
};
